module.exports = __webpack_public_path__ + "img/chapter_marker.ae50f7cf.svg";